export default function Footer() {
  return (
    <footer className="bg-[#0a1a1a] text-primary-foreground/60 py-12 border-t border-primary-foreground/10">
      <div className="max-w-6xl mx-auto px-5 grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
        <div className="md:col-span-2">
          <a href="/" className="flex items-center gap-2 font-bold text-lg text-primary-foreground mb-4">
            <span className="w-8 h-8 bg-primary flex items-center justify-center text-accent border border-accent/30 text-sm">D</span>
            <span>DANU MARKETING</span>
          </a>
          <p className="text-sm max-w-sm">
            We build websites, CRMs, and AI bots that capture, qualify, and book your next 50 clients — while you focus on what you do best.
          </p>
        </div>
        <div>
          <h3 className="text-accent font-semibold text-xs uppercase tracking-wider mb-4">Company</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/about" className="hover:text-accent transition-colors">About Us</a></li>
            <li><a href="/#services" className="hover:text-accent transition-colors">Services</a></li>
            <li><a href="/process" className="hover:text-accent transition-colors">Our Process</a></li>
            <li><a href="/#results" className="hover:text-accent transition-colors">Results</a></li>
            <li><a href="/#pricing" className="hover:text-accent transition-colors">Pricing</a></li>
            <li><a href="/locations-directory" className="hover:text-accent transition-colors">Areas We Serve</a></li>
            <li><a href="/contact" className="hover:text-accent transition-colors">Contact Us</a></li>
          </ul>
        </div>
        <div>
          <h3 className="text-accent font-semibold text-xs uppercase tracking-wider mb-4">Legal</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/privacy" className="hover:text-accent transition-colors">Privacy Policy</a></li>
            <li><a href="/terms" className="hover:text-accent transition-colors">Terms of Service</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-5 pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs">
        <p>© {new Date().getFullYear()} Danu Marketing. All rights reserved.</p>
      </div>
    </footer>
  );
}